import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import IntentButton, { Intent } from "../input/intent-button";

export default function ConfirmDeleteDialog({
  open,
  handleClose,
  item = null,
  onDelete,
  idProp,
  nameProp = "name",
  itemType,
  title = null,
  text = null,
  buttonText = null
}: any) {
  if (!item) {
    return <div />;
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {title || `Confirm Remove ${itemType}`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {text ||
            `Are you sure you want to remove ${item[nameProp]}?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()}>Cancel</Button>
        <IntentButton
          intent={Intent.ERROR}
          onClick={() => {
            onDelete(item[idProp]);
            handleClose();
          }}
        >
          {buttonText || "Delete"}
        </IntentButton>
      </DialogActions>
    </Dialog>
  );
}
